import axios from 'axios';

const API_URL = `/proxy/stakeholder`;

class SharedService {
    uploadFile(entity) {
        return axios.post(`${API_URL}/saveContent`, entity);
    }

    getFile(fileId) {
        return `${API_URL}/getFile/${fileId}`;
    }

    getFileByCategory(fileId) {
        return `${API_URL}/getFile?category=documents&fileId=${fileId}`;
    }
}

export default new SharedService();